import React, { useMemo } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import renderHTML from "lib/render-html";

type BlogCardStyleProps = {
  mb?: number;
  my?: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: (props: BlogCardStyleProps) => (props.mb ? props.mb : 0),
      position: "relative",
      boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 15%)",
      overflow: "hidden",
      "&:hover": {
        // boxShadow: "0px 8px 16px 0px rgba(0, 174, 241, .5)",
        outline: `1px solid ${theme.palette.primary.main}`,
        // "&::after": {
        //   content: '""',
        //   display: "block",
        //   backgroundColor: theme.palette.primary.main,
        //   height: 8,
        //   left: -1,
        //   right: -1,
        //   bottom: -8,
        //   position: "absolute",
        // },
      },

      "& .chip": {
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
      },
      "& .author_date": {
        display: "flex",
        justifyContent: "space-between",
        marginTop: theme.spacing(1),
      },
    },
    media: {
      minHeight: 180,
      position: "relative",
    },
    actionHighlight: {
      backgroundColor: theme.palette.common.white,
    },
  })
);
interface BlogCardProps extends BlogCardStyleProps {
  imagePath?: string;
  title?: string;
  link: string;
  category: string;
  author: string;
  createdOn: string;
  content?: string;
}
const BlogCard: React.FC<BlogCardProps> = (props) => {
  const classes = useStyles(props);
  const { imagePath, title, category, author, createdOn, link, content } =
    props;

  const filteredContent = useMemo(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const textContent = doc.body.textContent || "";
    return textContent.trim().substring(0, 200);
  }, [content]);

  return (
    <Card className={classes.root}>
      <CardActionArea
        tabIndex={-1}
        disableRipple
        href={link}
        target="_blank"
        classes={{ focusHighlight: classes.actionHighlight }}
      >
        <CardMedia
          className={classes.media}
          title="Contemplative Reptile"
          image={imagePath}
        ></CardMedia>
        <CardContent>
          <Chip
            label={renderHTML(category)}
            color="primary"
            size="small"
            variant="outlined"
            className="chip"
          />
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            paragraph
            className="textEllipsis__one"
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            component="p"
            paragraph
            className="textEllipsis__five"
          >
            {renderHTML(filteredContent)}
          </Typography>

          <div className="author_date">
            <Typography variant="caption">By : {author}</Typography>
            <Typography variant="caption">
              Date : {moment(createdOn).format("DD-MM-YYYY")}
            </Typography>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default BlogCard;
